import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiUsers,
  FiGlobe,
  FiSettings,
  FiChevronDown,
  FiChevronRight,
  FiMenu,
  FiX,
  FiUserPlus,
  FiUser,
  FiDollarSign
} from 'react-icons/fi';
import './Sidebar.css';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { name: 'Dashboard', icon: <FiHome />, path: '/', submenu: [] },
    { name: 'Company', icon: <FiHome />, path: 'ViewCompany', submenu: [] },

    {
      name: 'Set Up',
      icon: <FiSettings />,
      path: null,
      submenu: [
        { name: 'Department', path: '/ViewDepartment', icon: <FiUser /> },
        { name: 'Employee Type', path: '/ViewEmployeetype', icon: <FiUser /> },
        { name: 'Role', path: '/ViewRole', icon: <FiUser /> },
        { name: 'Bank Type', path: '/ViewBanktype', icon: <FiDollarSign /> },
        { name: 'Registration Type', path: '/ViewRegistrationtype', icon: <FiSettings /> },
        { name: 'Registration Fee', path: '/ViewRegistrationFee', icon: <FiSettings /> },
        { name: 'Country', path: '/Country', icon: <FiGlobe /> },
        { name: 'Region', path: '/Regions', icon: <FiGlobe /> },
        { name: 'District', path: '/District', icon: <FiGlobe /> },
        { name: 'Projects', path: '/ViewProjects', icon: <FiGlobe /> },
      ]
    },
    {
      name: 'HRM',
      icon: <FiUserPlus />,
      path: null,
      submenu: [
        { name: 'Employee', path: '/employeelist', icon: <FiUser /> },
        { name: 'Id Card', path: '/IDCARD', icon: <FiUser /> },

      ]
    },
    {
      name: 'Partiners',
      icon: <FiUsers />,
      path: null,
      submenu: [{ name: 'Member Registration', path: '/Members', icon: <FiUsers /> }]
    },
    {
      name: 'Finance',
      icon: <FiDollarSign />,
      path: null,
      submenu: [{ name: 'Member Payments', path: '/Payments', icon: <FiDollarSign /> }],

    },
    { name: 'Settings', icon: <FiSettings />, path: '/settings', submenu: [] }
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setSidebarOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSubmenu = (name) => setActiveSubmenu(activeSubmenu === name ? null : name);
  const toggleSidebar = () => isMobile ? setSidebarOpen(!sidebarOpen) : setIsCollapsed(!isCollapsed);
  const closeSidebarOnMobile = () => { if (isMobile) setSidebarOpen(false); };

  return (
    <>
      <button
        className={`mobile-menu-button ${sidebarOpen ? 'hidden' : ''}`}
        onClick={toggleSidebar}
      >
        <FiMenu size={24} />
      </button>

      {sidebarOpen && isMobile && (
        <div className="sidebar-overlay" onClick={closeSidebarOnMobile} />
      )}

      <div className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobile ? 'mobile' : ''} ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          {/* {(!isCollapsed || isMobile) && <h2>HALDOOR</h2>} */}
          {(!isCollapsed || isMobile) && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '10px' }}>
            <img
              src="/logoo.png"
              alt="HALDOOR"
              style={{ height: '60px', width: 'auto' }}
            />
          </div>
          
          )}

          <button className="toggle-btn" onClick={toggleSidebar}>
            {isMobile ? <FiX /> : (isCollapsed ? <FiMenu /> : <FiX />)}
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul>
            {menuItems.map((item) => (
              <li key={item.name}>
                {item.submenu.length > 0 ? (
                  <>
                    <div className="menu-item" onClick={() => toggleSubmenu(item.name)}>
                      <span className="icon">{item.icon}</span>
                      {(!isCollapsed || isMobile) && (
                        <>
                          <span>{item.name}</span>
                          <span className="arrow">
                            {activeSubmenu === item.name ? <FiChevronDown /> : <FiChevronRight />}
                          </span>
                        </>
                      )}
                    </div>
                    {(!isCollapsed || isMobile) && (
                      <ul className={`submenu ${activeSubmenu === item.name ? 'open' : ''}`}>
                        {item.submenu.map((subItem) => (
                          <li key={subItem.name}>
                            <NavLink
                              to={subItem.path}
                              className={({ isActive }) => isActive ? 'active' : ''}
                              onClick={closeSidebarOnMobile}
                            >
                              {subItem.icon && <span className="submenu-icon">{subItem.icon}</span>}
                              <span>{subItem.name}</span>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
                    onClick={closeSidebarOnMobile}
                  >
                    <span className="icon">{item.icon}</span>
                    {(!isCollapsed || isMobile) && <span>{item.name}</span>}
                  </NavLink>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
